jQuery(function ($) {
  $('.breed-search .form-check-input').on('change', function () {
    $(this).closest('.breed-search').submit();
  });
});
